import _ from 'lodash'

import {
  LIST_ROLES_STARTED,
  LIST_ROLES_COMPLETED,
  LIST_ROLES_FAILED,
  DELETE_ROLE_STARTED,
  DELETE_ROLE_COMPLETED,
  DELETE_ROLE_FAILED,
  CLEAR_STATES
} from '@/store/types'
import { marshalRole } from '@/utils/marshal'

import createRoleForm from './roles_list/create_role_form'

import { ITEM_PER_PAGE_FOR_PLACEHOLDER } from '@/config'

function getDefaultState () {
  return {
    roles: [],

    loading: false,
    error: undefined,
    actionError: undefined
  }
}

export default {
  namespaced: true,
  modules: {
    createRoleForm
  },

  state: getDefaultState(),
  getters: {},

  mutations: {
    // List roles
    [LIST_ROLES_STARTED] (state) {
      state.loading = true
      state.roles = new Array(ITEM_PER_PAGE_FOR_PLACEHOLDER).fill({})
    },
    [LIST_ROLES_COMPLETED] (state, payload) {
      const { roles, isMarshalNeeded } = payload
      if (isMarshalNeeded) {
        state.roles = _.cloneDeep(roles.map(marshalRole))
      } else {
        state.roles = _.cloneDeep(roles)
      }
      state.loading = false
      state.error = undefined
    },
    [LIST_ROLES_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Delete role
    [DELETE_ROLE_STARTED] (state, roleId) {
      const roleIndex = state.roles.findIndex(role => role.id === roleId)
      if (roleIndex === -1) throw new Error('role not find')
      state.roles[roleIndex].deleting = true
    },
    [DELETE_ROLE_COMPLETED] (state, roleId) {
      state.roles = state.roles.filter(role => role.id !== roleId)
      state.actionError = undefined
    },
    [DELETE_ROLE_FAILED] (state, payload) {
      const { roleId, err } = payload
      const roleIndex = state.roles.findIndex(role => role.id === roleId)
      if (roleIndex === -1) throw new Error('role not find')
      state.roles[roleIndex].deleting = false
      state.actionError = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async list ({ commit, rootState: { client = undefined } }) {
      try {
        commit(LIST_ROLES_STARTED)
        const roles = await client.managementClient.listRoles()
        commit(LIST_ROLES_COMPLETED, {
          roles: roles,
          isMarshalNeeded: true
        })
      } catch (err) {
        commit(LIST_ROLES_FAILED, err)
      }
    },
    async deleteRole ({ commit, rootState: { client = undefined } }, roleId) {
      try {
        commit(DELETE_ROLE_STARTED, roleId)
        await client.managementClient.deleteRole(roleId)
        commit(DELETE_ROLE_COMPLETED, roleId)
      } catch (err) {
        commit(DELETE_ROLE_FAILED, { roleId, err })
      }
    }
  }
}
